import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Icon from "./icon.svg";
import IconOpen from "./iconOpen.svg";
import "./InfoIcon.scss";
const InfoIcon = ({ onClick, isOpen }) => {
    return _jsx(_Fragment, { children: isOpen ? _jsx(IconOpen, { onClick: onClick, className: "infoIcon__svg" }) : _jsx(Icon, { className: "infoIcon__svg" }) });
};
export default InfoIcon;
//# sourceMappingURL=InfoIcon.js.map